
import { TranslationRecord } from '../../types';

export const cookiePolicy: TranslationRecord = {
  // Cookie Policy Page
  cookiePolicy: 'Cookie Policy',
  cookiePolicyTitle: 'Cookie Policy',
  lastUpdated: 'Last Updated',
  
  // Introduction
  cookiePolicyIntro: 'Introduction',
  cookiePolicyEffectiveDate: 'Effective Date',
  cookiePolicyDescription: 'This Cookie Policy explains how Loena Luxury Suites uses cookies and similar technologies on our website loenasuites.com. We use cookies to enhance your browsing experience, analyze site traffic, and personalize content.',
  
  // What are cookies
  whatAreCookies: 'What Are Cookies?',
  cookieDefinition: 'Cookies are small text files that are stored on your device (computer, tablet, or mobile) when you visit a website. They are widely used to make websites work more efficiently and provide information to the website owners.',
  cookiePurpose: 'Cookies that are set by the website owner (in this case, Loena Luxury Suites) are called "first party cookies". Cookies that are set by parties other than the website owner are called "third party cookies". Third party cookies enable third party features or functionality to be provided on or through the website.',
  
  // Types of cookies we use
  cookieTypes: 'Types of Cookies We Use',
  
  // Essential cookies
  necessaryCookies: 'Necessary Cookies',
  necessaryCookiesDescription: 'These cookies are essential for the Website to function properly. They enable core functionality such as security, network management, and language preferences. You cannot opt out of these cookies as the Website cannot function properly without them.',
  
  // Preference cookies
  functionalCookies: 'Functional Cookies',
  functionalCookiesDescription: 'These cookies enable the Website to remember information that changes the way the Website behaves or looks, like your preferred language or the region you are in. They help us to personalize your experience on our Website.',
  
  // Statistics cookies
  analyticsCookies: 'Analytics Cookies',
  analyticsCookiesDescription: 'These cookies collect information about how visitors use our Website, such as which pages visitors go to most often and if they receive error messages from web pages. They help us improve our Website\'s performance and functionality.',
  analyticsSpecificCookies: 'Specific analytics cookies we use on this website',
  
  // Marketing cookies
  marketingCookies: 'Marketing Cookies',
  marketingCookiesDescription: 'These cookies track your online activity to help advertisers deliver more relevant advertising or to limit how many times you see an ad. These cookies can share that information with other organizations or advertisers.',
  
  // Managing cookies
  managingCookies: 'Managing Cookie Preferences',
  managingCookiesDescription: 'You can change your cookie preferences at any time by clicking the button below. You can also manage cookies through your browser settings.',
  manageCookiePreferences: 'Manage Cookie Preferences',
  browserSettings: 'Most browsers allow you to control cookies through their settings. These links explain how to manage cookies in your browser:',
  
  // Contact us
  contactUs: 'Contact Us',
  cookiePolicyContact: 'If you have any questions about our use of cookies, please contact us',
};
